import React from 'react'
import { useFragment, graphql } from 'react-relay'

import { YStack } from 'tamagui'
import { Image, Text } from '@newComponents'

import { HOST_NAME } from '@data/config/url'

import { EventScreenNewCoverPhoto_event$key } from './__generated__/EventScreenNewCoverPhoto_event.graphql'

const BACKGROUNDS = [
  'purple-yellow_zbyzdUESq.png',
  'pink-yellow_UvKUtm5f3.png',
  'blue-purple_F4x1_B8WX.png',
  'blue-teal_HwODg9qh1.png',
  'purple-blue_t3kh8e78Bl.png',
]

export const EventScreenNewCoverPhoto = ({
  event,
}: {
  event: EventScreenNewCoverPhoto_event$key
}) => {
  const data = useFragment(
    graphql`
      fragment EventScreenNewCoverPhoto_event on Event {
        name
        rowId
        prettyUrl
        visibility

        coverPhoto {
          # Cover photo: 368px wide, dpr 3
          transformUrl(transform: { w: 368, dpr: 3 })
        }

        updatedAt
      }
    `,
    event
  )

  if (data.coverPhoto?.transformUrl) {
    return (
      <Image
        alt={`Cover Photo for ${data.name}`}
        src={data.coverPhoto.transformUrl}
        // @ts-expect-error boxShadow is web-only
        boxShadow='$boxShadowLight'
        width='100%'
        $gtXs={{
          borderRadius: '$8',
          maxWidth: 537,
        }}
        $gtSm={{
          maxWidth: '100%',
        }}
      />
    )
  }

  return (
    <Image
      alt={`Cover Photo for ${data.name}`}
      src={`${HOST_NAME}/social/event/${data.prettyUrl}/card.svg?${data.updatedAt}`}
      aspectRatio={2}
      // @ts-expect-error boxShadow is web-only
      boxShadow='$boxShadowLight'
      width='100%'
      $gtXs={{
        borderRadius: '$8',
        maxWidth: 537,
      }}
      $gtSm={{
        maxWidth: '100%',
      }}
    />
  )
}
